import React, { useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import config from '../config/index.json';
import { Link } from 'react-router-dom';


function Network() {

    const { images } = config;
    const { menarini, bayer, aboca, lisapharma, nordic } = images;
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const handleClick = (index: number) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <section id='network' className='text-center p-32'>
            <h3 data-aos="fade-down" className='text-4xl text-blackBlue' data-aos-delay="200">Le Aziende del Network</h3>
            <div className='grid grid-cols-5 py-12'>
                <img data-aos="fade-down" data-aos-duration="1000" data-aos-delay="300" src={menarini} />
                <img data-aos="fade-down" data-aos-duration="1000" data-aos-delay="350" src={bayer} />
                <img data-aos="fade-down" data-aos-duration="1000" data-aos-delay="400" src={aboca} />
                <img data-aos="fade-down" data-aos-duration="1000" data-aos-delay="450" src={lisapharma} />
                <img data-aos="fade-down" data-aos-duration="1000" data-aos-delay="500" src={nordic} />
            </div>
            <Link
                to=''
                data-aos-offset="350"
                className='inline-block mt-8 text-darkblue bg-lightBlue px-12 py-6 relative text-sm font-semibold cursor-pointer transition hover:duration-700 ease-linear hover:transition-all hover:bg-darkblue hover:text-white hover:scale-105 btnDemo'>Vedi tutte le aziende</Link>
        </section>
    )
}

export default Network